/**
 * FleetPanel — admin /admin → Fleet root.
 *
 * Phase 2 P2 decomposition · 2026-06. The original FleetPanel.jsx had
 * grown to ~1,170 LOC with DriversTab, PassengersTab, all the modal
 * components, the diagnose modal, and two sub-tables inlined. Splitting
 * them into `fleet/*.jsx` keeps each module small + testable, and this
 * orchestrator is now strictly a 4-button tab strip + a branching
 * render switch — no business logic of its own.
 *
 * Behaviour is byte-identical to the pre-decomposition version: same
 * testids, same props shape, same parent-driven onRefresh contract.
 * Any change to behaviour would be a separate slice.
 */
import React from "react";
import { DriversTab } from "./fleet/DriversTab";
import { PassengersTab } from "./fleet/PassengersTab";
import { CyclesTable, AccountRidesTable } from "./fleet/SubTables";

export const FleetPanel = ({
  fleetTab, setFleetTab, drivers, passengers, cycles, accountRides, rides,
  onDelete, onToggleAccount, onRefresh,
}) => (
  <div className="bg-white" data-testid="fleet-panel">
    <div className="px-4 py-3 border-b border-border flex gap-1 overflow-x-auto">
      <button
        onClick={() => setFleetTab("drivers")}
        className={`flex-1 py-2 label-mini transition-colors border whitespace-nowrap px-3 ${fleetTab === "drivers" ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-border hover:bg-secondary"}`}
        data-testid="fleet-tab-drivers"
      >
        Drivers · {drivers.length}
      </button>
      <button
        onClick={() => setFleetTab("passengers")}
        className={`flex-1 py-2 label-mini transition-colors border whitespace-nowrap px-3 ${fleetTab === "passengers" ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-border hover:bg-secondary"}`}
        data-testid="fleet-tab-passengers"
      >
        Passengers · {passengers.length}
      </button>
      <button
        onClick={() => setFleetTab("cycles")}
        className={`flex-1 py-2 label-mini transition-colors border whitespace-nowrap px-3 ${fleetTab === "cycles" ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-border hover:bg-secondary"}`}
        data-testid="fleet-tab-cycles"
      >
        Cycles · {cycles?.length || 0}
      </button>
      <button
        onClick={() => setFleetTab("accounts")}
        className={`flex-1 py-2 label-mini transition-colors border whitespace-nowrap px-3 ${fleetTab === "accounts" ? "bg-[#002FA7] text-white border-[#002FA7]" : "border-border hover:bg-secondary"}`}
        data-testid="fleet-tab-accounts"
      >
        Accounts · {accountRides?.length || 0}
      </button>
    </div>

    <div className="p-4 space-y-2">
      {fleetTab === "drivers" && (
        <DriversTab drivers={drivers} rides={rides} onRefresh={onRefresh} />
      )}
      {fleetTab === "passengers" && (
        <PassengersTab passengers={passengers} onToggleAccount={onToggleAccount} onDelete={onDelete} />
      )}
      {fleetTab === "cycles" && <CyclesTable cycles={cycles} />}
      {fleetTab === "accounts" && <AccountRidesTable rides={accountRides} />}
    </div>
  </div>
);

export default FleetPanel;
